import { Script } from 'gatsby'
import React from 'react'
import { useSiteSettings } from '../../hooks/useSiteSettings'
import { isNullOrWhiteSpace } from '../../utilities/string'

export const CookieTractorTracking = () => {
  const siteSettings = useSiteSettings()

  const trackingId = siteSettings?.cookieTractorId ?? ''
  const trackingUrl = siteSettings?.cookieTractorUrl ?? ''

  return !isNullOrWhiteSpace(trackingId) && !isNullOrWhiteSpace(trackingUrl) ? (
    <Script
      src={trackingUrl}
      data-lang={siteSettings?.cookieTractorLang}
      data-id={trackingId}
    ></Script>
  ) : null
}
